import {ControlValueAccessor} from "@angular/forms";
import {Directive, EventEmitter, Input, Output} from "@angular/core";
import {SearchControlSelectObjects} from "../../select/search-control-select-objects";

/**
 * Selector used to select the input common-controls. All common-controls that will participate in the SearchForm should provide itself with this selector.
 * @type {string}
 */
export class SearchControlFieldSelector {
}

export function registerSearchControl(type: any): any[] {
    return [
        {provide: SearchControlFieldSelector, useExisting: type, multi: true}
    ];
}

/**
 * Abstract class that implements methods for the search inputs
 */
@Directive()
export class AbstractSearchControlComponent implements ControlValueAccessor {
    @Input() public placeholder: string;
    @Input() public label: string;
    @Input() public elementId: string;
    @Input() public removable: boolean = true;
    @Output() public removeControl: EventEmitter<any>; // Event triggered when the control is in an extended search and requested to be removed
    @Output() public valueChange: EventEmitter<any>;
    public _value: any;

    constructor() {
        this.removeControl = new EventEmitter<any>();
        this.valueChange = new EventEmitter();
    }

    /**
     *
     */
    propagateChange: any = () => {
    };

    /**
     *
     * @returns {any}
     */
    get value(): any {
        return this._value;
    }

    /**
     *
     * @param value
     */
    @Input()
    set value(value: any) {
        if (value !== this._value) {
            this.writeValue(value);
            this.propagateChange(value);
            this.valueChange.emit(value);
        }
    }

    /**
     *
     * @param obj
     */
    writeValue(obj: any): void {
        this._value = obj;
    }

    /**
     *
     * @param fn
     */
    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    /**
     *
     * @param fn
     */
    registerOnTouched(fn: any): void {
    }

    /**
     *
     * @param isDisabled
     */
    setDisabledState(isDisabled: boolean): void {
    }

    /**
     * When working as an extended filter the subclass can call this method to be removed from the search
     */
    onRemove(): void {
        this.removeControl.emit(null);
    }

    setSearchControlSelectObjects(searchControlSelectObjects: SearchControlSelectObjects): void {
    }
}
